import * as React from "react";
const SvgList = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M21 16.965a1.035 1.035 0 0 1 0 2.07H9a1.035 1.035 0 0 1 0-2.07zm-17 1a.035.035 0 0 0-.035.035c0 .02.016.035.035.035q.015 0 .024-.01L4.035 18l-.01-.024A.04.04 0 0 0 4 17.965m17-7a1.035 1.035 0 0 1 0 2.07H9a1.035 1.035 0 0 1 0-2.07zm-17 1a.035.035 0 0 0-.035.035c0 .02.016.035.035.035q.015 0 .024-.01L4.035 12l-.01-.024A.04.04 0 0 0 4 11.965m17-7a1.035 1.035 0 0 1 0 2.07H9a1.035 1.035 0 0 1 0-2.07zm-17 1A.035.035 0 0 0 3.965 6c0 .02.016.035.035.035q.015 0 .024-.01L4.035 6l-.01-.024A.04.04 0 0 0 4 5.965M6.035 18a2.035 2.035 0 0 1-4.06.208L1.966 18l.01-.208a2.035 2.035 0 0 1 4.06.208m0-6a2.035 2.035 0 0 1-4.06.208L1.966 12l.01-.208a2.035 2.035 0 0 1 4.06.208m0-6a2.035 2.035 0 0 1-4.06.208L1.966 6l.01-.208A2.035 2.035 0 0 1 4 3.965l.208.01A2.035 2.035 0 0 1 6.035 6"
}));
export default SvgList;
//# sourceMappingURL=List.js.map